import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconFilters = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.17 17.9995C6.3766 17.414 6.75974 16.907 7.2666 16.5483C7.77346 16.1897 8.37909 15.9971 9 15.9971C9.62091 15.9971 10.2265 16.1897 10.7334 16.5483C11.2403 16.907 11.6234 17.414 11.83 17.9995H22V19.9995H11.83C11.6234 20.5851 11.2403 21.0921 10.7334 21.4507C10.2265 21.8094 9.62091 22.002 9 22.002C8.37909 22.002 7.77346 21.8094 7.2666 21.4507C6.75974 21.0921 6.3766 20.5851 6.17 19.9995H2V17.9995H6.17ZM12.17 10.9995C12.3766 10.414 12.7597 9.90695 13.2666 9.54831C13.7735 9.18967 14.3791 8.99707 15 8.99707C15.6209 8.99707 16.2265 9.18967 16.7334 9.54831C17.2403 9.90695 17.6234 10.414 17.83 10.9995H22V12.9995H17.83C17.6234 13.5851 17.2403 14.0921 16.7334 14.4507C16.2265 14.8094 15.6209 15.002 15 15.002C14.3791 15.002 13.7735 14.8094 13.2666 14.4507C12.7597 14.0921 12.3766 13.5851 12.17 12.9995H2V10.9995H12.17ZM6.17 3.99952C6.3766 3.41399 6.75974 2.90695 7.2666 2.54831C7.77346 2.18967 8.37909 1.99707 9 1.99707C9.62091 1.99707 10.2265 2.18967 10.7334 2.54831C11.2403 2.90695 11.6234 3.41399 11.83 3.99952H22V5.99952H11.83C11.6234 6.58505 11.2403 7.09209 10.7334 7.45073C10.2265 7.80938 9.62091 8.00197 9 8.00197C8.37909 8.00197 7.77346 7.80938 7.2666 7.45073C6.75974 7.09209 6.3766 6.58505 6.17 5.99952H2V3.99952H6.17ZM9 5.99952C9.26522 5.99952 9.51957 5.89416 9.70711 5.70663C9.89464 5.51909 10 5.26474 10 4.99952C10 4.7343 9.89464 4.47995 9.70711 4.29241C9.51957 4.10488 9.26522 3.99952 9 3.99952C8.73478 3.99952 8.48043 4.10488 8.29289 4.29241C8.10536 4.47995 8 4.7343 8 4.99952C8 5.26474 8.10536 5.51909 8.29289 5.70663C8.48043 5.89416 8.73478 5.99952 9 5.99952ZM15 12.9995C15.2652 12.9995 15.5196 12.8942 15.7071 12.7066C15.8946 12.5191 16 12.2647 16 11.9995C16 11.7343 15.8946 11.48 15.7071 11.2924C15.5196 11.1049 15.2652 10.9995 15 10.9995C14.7348 10.9995 14.4804 11.1049 14.2929 11.2924C14.1054 11.48 14 11.7343 14 11.9995C14 12.2647 14.1054 12.5191 14.2929 12.7066C14.4804 12.8942 14.7348 12.9995 15 12.9995ZM9 19.9995C9.26522 19.9995 9.51957 19.8942 9.70711 19.7066C9.89464 19.5191 10 19.2647 10 18.9995C10 18.7343 9.89464 18.4799 9.70711 18.2924C9.51957 18.1049 9.26522 17.9995 9 17.9995C8.73478 17.9995 8.48043 18.1049 8.29289 18.2924C8.10536 18.4799 8 18.7343 8 18.9995C8 19.2647 8.10536 19.5191 8.29289 19.7066C8.48043 19.8942 8.73478 19.9995 9 19.9995Z"
        fill="#3643BA"
        strokeWidth="0.1"
      />
    </svg>
  );
};

IconFilters.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconFilters.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconFilters;
